import { useState } from "react";
import { BarChart3, Briefcase, Globe, LayoutDashboard, Menu, Megaphone, UserCog } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

// Client area navigation: 5 sections; only the tabs the role can read are listed, empty sections disappear.
export const AREA_SECTIONS = [
  ["Panoramica", LayoutDashboard, ["overview", "support"]],
  ["Sito e CRM", Globe, ["site", "domains", "leads", "contacts", "pipeline", "activities", "sheet"]],
  ["Marketing", Megaphone, ["sources", "automations", "kpi"]],
  ["Operazioni", Briefcase, ["calendar", "orders", "subscriptions", "payments"]],
  ["Account", UserCog, ["plan", "wallet", "members", "support_access", "privacy", "export", "trash"]],
];

const sections = (tabs) => AREA_SECTIONS.map(([g, Icon, ks]) => [g, Icon, ks.map((k) => tabs.find((t) => t[0] === k)).filter(Boolean)]).filter((s) => s[2].length);

function Items({ tabs, value, onPick, prefix }) {
  return sections(tabs).map(([g, Icon, items]) => (
    <div key={g} className="mb-4" role="group" aria-label={g} data-testid={`${prefix}-section-${items[0][0]}`}>
      <p className="mb-1 flex items-center gap-2 px-3 text-xs font-semibold uppercase tracking-[0.12em] text-slate-700"><Icon size={14} className="text-sky-700" />{g}</p>
      {items.map(([k, l]) => (
        <button key={k} type="button" onClick={() => onPick(k)} aria-current={value === k ? "page" : undefined} data-testid={`${prefix}-${k}`}
          className={`flex w-full items-center rounded-lg border-l-4 px-3 py-2 text-left text-[15px] transition-colors ${value === k
            ? "border-teal-500 bg-sky-50 font-semibold text-navy-900" : "border-transparent text-slate-800 hover:bg-slate-100"}`}>{l}</button>))}
    </div>));
}

export function AreaSideNav({ tabs, value, onChange }) {
  return (
    <nav className="sticky top-20 hidden max-h-[calc(100dvh-6rem)] w-60 shrink-0 overflow-y-auto overscroll-contain rounded-xl border border-slate-200 bg-white p-2 pt-4 lg:block" aria-label="Sezioni" data-testid="area-tabs">
      <Items tabs={tabs} value={value} onPick={onChange} prefix="area-tab" />
    </nav>);
}

export function AreaMobileNav({ tabs, value, onChange }) {
  const [open, setOpen] = useState(false);
  const cur = sections(tabs).flatMap(([g, , items]) => items.map((t) => [g, t])).find(([, t]) => t[0] === value);
  return (
    <div className="lg:hidden">
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <Button variant="outline" className="h-12 w-full justify-start gap-3 bg-white text-left text-[15px] text-slate-900" data-testid="area-mobile-nav">
            <Menu size={18} className="text-sky-700" /><span className="truncate">{cur ? <>{cur[0] !== cur[1][1] && <span className="text-slate-600">{cur[0]} · </span>}<b>{cur[1][1]}</b></> : "Sezioni"}</span></Button>
        </SheetTrigger>
        <SheetContent side="left" className="w-[88vw] max-w-sm overflow-y-auto p-3 pt-10" data-testid="area-mobile-drawer">
          <SheetHeader className="mb-3 px-3 text-left"><SheetTitle>Sezioni</SheetTitle></SheetHeader>
          <Items tabs={tabs} value={value} onPick={(k) => { onChange(k); setOpen(false); }} prefix="area-mobile" />
        </SheetContent>
      </Sheet>
    </div>);
}
